import { HBAK } from "@constants/common";
import Honeybadger from "@honeybadger-io/js";
import { decryptKey, extractApiErrorMessage, getCurrentReporterVersion, reportToHoneybadger, resolveReporterOptions, } from "@utils/common";
import consoleLogFormatted from "@utils/consoleLogFormatted";
import { onBegin } from "lifecycle/onBegin";
import { onEnd } from "lifecycle/onEnd";
import { onTestBegin } from "lifecycle/onTestBegin";
import { onTestEnd } from "lifecycle/onTestEnd";
import { preprocess } from "lifecycle/preprocess";
import test from "./fixtures";
import { initialize } from "./lifecycle/initialize";
class NeetoPlaywrightReporter {
    constructor(reporterOptions) {
        this.reportLifecycleError = async (lifecycle, error, additionalContext = {}) => {
            const errorMessage = extractApiErrorMessage(error);
            consoleLogFormatted.error(`${lifecycle} failed: ${errorMessage !== null && errorMessage !== void 0 ? errorMessage : String(error)}`);
            await reportToHoneybadger({
                context: {
                    lifecycle,
                    ciBuildId: this.ciBuildId,
                    ...additionalContext,
                },
                error,
                title: `${lifecycle} - Fire and Forget Handler`,
            });
        };
        this.preprocess = (params) => preprocess(this, params);
        this.onBegin = (config, rootSuite) => {
            onBegin(this, config, rootSuite).catch(error => this.reportLifecycleError("onBegin", error, {
                configDetails: JSON.stringify(config, null, 2),
            }));
        };
        this.onTestBegin = (test, result) => {
            onTestBegin(this, test, result).catch(error => this.reportLifecycleError("onTestBegin", error, {
                testTitle: test.title,
                testLocation: test.location,
            }));
        };
        this.onTestEnd = (testCase, testResult) => {
            onTestEnd(this, testCase, testResult).catch(error => this.reportLifecycleError("onTestEnd", error, {
                testTitle: testCase.title,
                testLocation: testCase.location,
                testStatus: testResult.status,
                testDuration: testResult.duration,
            }));
        };
        this.onEnd = (fullResult) => onEnd(this, fullResult);
        const options = resolveReporterOptions(reporterOptions);
        this.attempts = {};
        this.tags = options.tags;
        this.ciBuildId = options.ciBuildId;
        this.title = options.title;
        this.commitId = options.commitId;
        this.author = options.author;
        this.branch = options.branch;
        this.smartOrchestration = options.smartOrchestration;
        this.groupBySpecs = options.groupBySpecs;
        this.hasPreprocessRun = false;
        this.testResultCalls = [];
        this.totalTestCount = 0;
        this.hasRunStarted = false;
        this.heartbeatManager = null;
        this.rootDir = "";
        this.currentShard = 0;
        this.progressBars = [];
        this.startedAttempts = new Set();
        this.shouldNotReportTest = false;
        this.pendingTestBegins = new Set();
        this.pendingTestEnds = new Set();
        this.apiKey = options.apiKey;
        Honeybadger.configure({
            apiKey: decryptKey(HBAK),
            environment: options.baseURL.includes(".net") ? "staging" : "production",
        });
        Honeybadger.setContext({
            ...options,
            reporterVersion: getCurrentReporterVersion(),
        });
        initialize(this, options);
    }
    onStdOut(chunk, test) {
        test && consoleLogFormatted.bold(`Log from test "${test.title}"`);
        consoleLogFormatted.log(chunk.toString());
    }
}
export default NeetoPlaywrightReporter;
export { test };
//# sourceMappingURL=index.js.map